import ResultControls from './ResultControls';

export default ResultControls;
